import Index from '@/pages/icon/Index';
import List from '@/pages/icon/List';
import Create from '@/pages/icon/Create';
import Detail from '@/pages/icon/Detail';

var serviceName = process.env.VUE_APP_SERVICE_NAME || 'Nichibyo';

export default {
  path: 'icon',
  component: Index,
  children: [
    {
      path: 'index',
      component: List
    },
    {
      path: 'create',
      component: Create,
      props: () => ({ serviceName })
    },
    {
      path: 'detail/:key',
      component: Detail,
      props: () => ({ serviceName })
    }
  ]
};
